import { useLoaderData } from "react-router-dom";
import { Link } from "react-scroll";
import classNames from "classnames";
import { Background, Parallax } from "react-parallax";
import { ReactComponent as IconCarrot } from "../../assets/icons/carrot.svg";
import "./freunde.style.scss";

export const Freunde = ({ data }) => {
    const loaderData = useLoaderData();
    const config = data || loaderData?.freunde;

    if (!config) return null;

    const {
        id = "freunde",
        image,
        imageAlt = "",
        headline,
        subHeadline,
        description,
        buttons = [],
        background,
        fontColor
    } = config;

    const headlineClass = classNames({
        'section-slider_headline': true,
        [`${background?.headline ?? "secondary"}-bg`]: true,
        [`${fontColor?.headline ?? "white"}-color`]: true
    });
    const subHeadlineClass = classNames({
        'section-slider_headline_sub': true,
        [`${background?.subHeadline ?? "secondary"}-bg`]: true,
        [`${fontColor?.subHeadline ?? "white"}-color`]: true
    });

    const ButtonContent = ({ text }) => (
        <>
            <span className="freunde_btn_carrot icon-carrot">
                <IconCarrot />
            </span>
            <span className="freunde_btn_text">{text}</span>
        </>
    );

    return (
        <section id={id} className="section section-slider section-freunde white-color">
            <div className="section-slider_container">
                <Parallax strength={100}>
                    <Background className="section-slider_bg">
                        {image && <img src={image} alt={imageAlt} />}
                    </Background>
                    <div className="section-slider_preview">
                        <h2 className="section-slider_h2__wrapper muur-h2__wrapper">
                            {headline && <div className={`muur-h2 ${headlineClass}`} data-aos="fade-up">{headline}</div>}
                            {subHeadline && <div className={`muur-h2_sub ${subHeadlineClass}`} data-aos="fade-up">{subHeadline}</div>}
                        </h2>
                    </div>
                    <div className="section-slider_content">
                        <div className="section-slider_row">
                            <div className="section-slider_description muur-description" data-aos="fade-up" dangerouslySetInnerHTML={{ __html: description }} />
                        </div>
                        {buttons.length > 0 && (
                            <div className="freunde_actions" data-aos="fade-up">
                                {buttons.map(({ text, anchor, link, target }, i) => (
                                    anchor
                                        ? (
                                            <Link key={i} className="freunde_btn" to={anchor} smooth delay={0} duration={600} offset={-120}>
                                                <ButtonContent text={text} />
                                            </Link>
                                        )
                                        : (
                                            <a key={i} className="freunde_btn" href={link ?? ""} target={target ?? "_blank"} rel="noopener noreferrer">
                                                <ButtonContent text={text} />
                                            </a>
                                        )
                                ))}
                            </div>
                        )}
                    </div>
                </Parallax>
            </div>
        </section>
    );
};

export default Freunde;
